// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-2264e0aa] {\n  width: 100%;\n  margin-bottom: 40px;\n}\n.card[data-v-2264e0aa]:last-child {\n  margin-bottom: 0;\n}\n.totalNumber[data-v-2264e0aa] {\n  color: #a8aeb8;\n  font-weight: 400;\n  font-size: 18px;\n}\n.warningText[data-v-2264e0aa] {\n  margin-bottom: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba(26, 123, 238, 0.2);\n  background: #eaefff;\n  width: 100%;\n  line-height: normal;\n  padding: 16px;\n}", ""]);
// Exports
module.exports = exports;
